import { render, staticRenderFns } from "./IsAuthorized.vue?vue&type=template&id=6ac7b388&"
import script from "./IsAuthorized.vue?vue&type=script&lang=js&"
export * from "./IsAuthorized.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports